import React from 'react';

const WhyUs = () => {
    return (
        <div className='w-75 mx-auto text-center my-5'>
            <h2 style={{ color: '#CC9817' }}>Why Shop With Us?</h2>
            <p style={{ color: '#54595F' }}>  We sell authentic and high-quality spices at an affordable rate.                   Keralaspicesonline.  com is the <br />
                best and top online seller of spices and herbs based on ratings and reviews by customers of <br />
                Keralaspicesonline.com
            </p>
            <div class="row">
                <div class="col">
                    <img src="https://www.keralaspicesonline.com/wp-content/uploads/2022/02/shopping-cart-sketch-large.png" alt="" />
                    <h5 style={{ color: '#CC9817' }}>Fast delivery</h5>
                    <p style={{ color: '#54595F' }}>We deliver parcels very quickly with help of <br /> our shipping partners</p>
                </div>
                <div class="col">
                    <img src="https://www.keralaspicesonline.com/wp-content/uploads/2022/02/chatting-speech-bubbles-hand-drawn-bubbles-couple-large.png" alt="" />
                    <h5 style={{ color: '#CC9817' }}>Outstanding support</h5>
                    <p style={{ color: '#54595F' }}> Our customer support is 24/7 – users rave <br /> about how we don’t rest until every issue is <br /> solved to their satisfaction</p>
                </div>
                <div class="col">
                    <img src="https://www.keralaspicesonline.com/wp-content/uploads/2022/02/shopping-cart-sketch-large.png" alt="" />
                    <h5 style={{ color: '#CC9817' }}>Amazing Reviews</h5>
                    <p style={{ color: '#54595F' }}>Check our reviews to know what our <br /> customer experiences.</p>
                </div>
            </div>
        </div>
    );
};

export default WhyUs;